import { SVGProps } from "react";

const MapsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.6">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.3335 6.66667C1.3335 3 4.3335 0 8.00016 0C11.6668 0 14.6668 3 14.6668 6.66667C14.6668 11.6 8.60016 15.7333 8.40016 15.8667C8.26683 15.9333 8.1335 16 8.00016 16C7.86683 16 7.7335 15.9333 7.60016 15.8667C7.40016 15.7333 1.3335 11.6 1.3335 6.66667ZM2.66683 6.66667C2.66683 10.2667 6.7335 13.6 8.00016 14.5333C9.26683 13.6 13.3335 10.2667 13.3335 6.66667C13.3335 3.73333 10.9335 1.33333 8.00016 1.33333C5.06683 1.33333 2.66683 3.73333 2.66683 6.66667ZM8.00016 4C6.5335 4 5.3335 5.2 5.3335 6.66667C5.3335 8.13333 6.5335 9.33333 8.00016 9.33333C9.46683 9.33333 10.6668 8.13333 10.6668 6.66667C10.6668 5.2 9.46683 4 8.00016 4ZM6.66683 6.66667C6.66683 7.4 7.26683 8 8.00016 8C8.7335 8 9.3335 7.4 9.3335 6.66667C9.3335 5.93333 8.7335 5.33333 8.00016 5.33333C7.26683 5.33333 6.66683 5.93333 6.66683 6.66667Z"
        fill="black"
      />
      <mask
        id="mask0_753_15739"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="14"
        height="16"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.3335 6.66667C1.3335 3 4.3335 0 8.00016 0C11.6668 0 14.6668 3 14.6668 6.66667C14.6668 11.6 8.60016 15.7333 8.40016 15.8667C8.26683 15.9333 8.1335 16 8.00016 16C7.86683 16 7.7335 15.9333 7.60016 15.8667C7.40016 15.7333 1.3335 11.6 1.3335 6.66667ZM2.66683 6.66667C2.66683 10.2667 6.7335 13.6 8.00016 14.5333C9.26683 13.6 13.3335 10.2667 13.3335 6.66667C13.3335 3.73333 10.9335 1.33333 8.00016 1.33333C5.06683 1.33333 2.66683 3.73333 2.66683 6.66667ZM8.00016 4C6.5335 4 5.3335 5.2 5.3335 6.66667C5.3335 8.13333 6.5335 9.33333 8.00016 9.33333C9.46683 9.33333 10.6668 8.13333 10.6668 6.66667C10.6668 5.2 9.46683 4 8.00016 4ZM6.66683 6.66667C6.66683 7.4 7.26683 8 8.00016 8C8.7335 8 9.3335 7.4 9.3335 6.66667C9.3335 5.93333 8.7335 5.33333 8.00016 5.33333C7.26683 5.33333 6.66683 5.93333 6.66683 6.66667Z"
          fill="white"
        />
      </mask>
    </g>
  </svg>
);

export default MapsIcon;
